import React from 'react'
import { ThemeProvider } from 'styled-components'
import { render as ReactDOMRender } from 'react-dom'
import html2pdf from 'html2pdf.js'

// Components
import Link from 'components/Link'
import Button from 'components/Button'
import Modal from 'components/Modal'
import RecoveryCodesPDFTemplate from 'modules/user/components/RecoveryCodesPDFTemplate'

// Styles
import theme from 'styles/theme'
import {
  Title,
  Description,
  RecoveryCodes,
  RecoveryCode,
  Buttons,
  StyledButton,
} from '../RegenerateRecoveryCodesModal.styles'

// Types
interface ThirdStepProps {
  recoveryCodes: string[]
  onNextStep: (goToStep?: number) => void
}

/**
 * Renders the third step for the Regenerate Recovery Codes modal
 */
export const ThirdStep: React.FC<ThirdStepProps> = ({
  onNextStep,
  recoveryCodes,
}) => {
  const handleCopyCodes = () => {
    const parsedRecoveryCodes = recoveryCodes.join().replaceAll(',', ' ')

    navigator.clipboard.writeText(parsedRecoveryCodes)
  }

  const handlePrintCodes = async () => {
    const container = document.createElement('div')
    ReactDOMRender(
      <ThemeProvider theme={theme}>
        <RecoveryCodesPDFTemplate recoveryCodes={recoveryCodes} />
      </ThemeProvider>,
      container
    )

    html2pdf(container, {
      filename: 'sketch_recovery_codes.pdf',
    })
  }

  return (
    <>
      <Modal.Body>
        <Title>Your New Recovery Codes</Title>
        <Description>
          Use these recovery codes to sign in if you lose access to the
          authentication app. Store them somewhere safe!
        </Description>
        <RecoveryCodes>
          {recoveryCodes.map((code, index) => (
            <RecoveryCode key={`${code}${index}`}>{code}</RecoveryCode>
          ))}
        </RecoveryCodes>
        <Buttons>
          <StyledButton onClick={handlePrintCodes} smaller>
            Print Codes (PDF)
          </StyledButton>
          <StyledButton onClick={() => handleCopyCodes} smaller>
            Copy Codes
          </StyledButton>
        </Buttons>
        <Link onClick={() => onNextStep(1)} isUnderlined external>
          Generate new recovery codes
        </Link>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => onNextStep()} smaller>
          Finish
        </Button>
      </Modal.Footer>
    </>
  )
}
